export const MINI_SITE_TAB_QUERYSTRING_KEY = 'miniSiteTab';
